const DAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Current time in UK (Europe/London) — handles GMT/BST automatically.
function londonNow() {
  const now = new Date();
  const weekday = new Intl.DateTimeFormat("en-US", { timeZone: "Europe/London", weekday: "long" }).format(now).toLowerCase();
  const hm = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit", hour12: false }).format(now);
  return { dayIdx: DAYS.indexOf(weekday), hm: hm === "24:00" ? "00:00" : hm };
}

function hoursFor(settings, type, dayName) {
  if (type === "delivery") {
    if (settings?.delivery?.paused) return { closed: true };
    return settings?.delivery?.day_hours?.[dayName];
  }
  return settings?.opening_hours?.[dayName];
}

// type: "delivery" | "collection"
export function dayWindow(settings, type) {
  const { dayIdx, hm } = londonNow();
  const t = hoursFor(settings, type, DAYS[dayIdx]);
  if (!t) return { closed: false, open: null, close: null, openNow: true };
  if (t.closed) return { closed: true, open: t.open, close: t.close, openNow: false };
  let openNow = true;
  if (t.open && t.close) {
    openNow = t.open <= t.close ? (t.open <= hm && hm <= t.close) : (hm >= t.open || hm <= t.close);
  }
  return { closed: false, open: t.open, close: t.close, openNow };
}

// Returns { dayLabel, time } for the next time the shop opens, or null if open now.
export function nextOpening(settings, type) {
  const { dayIdx, hm } = londonNow();
  if (dayIdx < 0) return null;
  for (let i = 0; i < 8; i++) {
    const idx = (dayIdx + i) % 7;
    const t = hoursFor(settings, type, DAYS[idx]);
    if (!t || t.closed || !t.open) continue;
    if (i === 0) {
      if (hm < t.open) return { dayLabel: "today", time: t.open };
      if (t.close && hm > t.close) continue; // already closed today, look ahead
      return null; // open now
    }
    return { dayLabel: i === 1 ? "tomorrow" : cap(DAYS[idx]), time: t.open };
  }
  return null;
}

export function windowLabel(w) {
  if (!w) return "";
  if (w.closed) return "not available today";
  if (!w.open || !w.close) return "available";
  return `${w.open}–${w.close}`;
}
